export const navigation = [
  { label: "Cost Review", href: "/#water" },
  { label: "The Edge", href: "/#edge" },
  { label: "How It Learns", href: "/#intelligence" },
  { label: "Contact", href: "/#contact" },
] as const;

export const comparisonCards = [
  {
    number: "01",
    title: "Monitoring software",
    description: "Tracks connected water data and reports changes.",
    highlighted: false,
  },
  {
    number: "02",
    title: "Treatment vendors",
    description: "Recommend the chemicals, equipment, or work they provide.",
    highlighted: false,
  },
  {
    number: "03",
    title: "Kratis",
    description:
      "Independently connects the charge, sample, and plant event—then recommends the least expensive justified next move and checks the result.",
    highlighted: true,
  },
] as const;

export const evidenceAccessMethods = [
  "Customer-approved records",
  "New measurements",
  "Licensed information",
  "Frontline partners",
  "Selective source ownership, when justified",
] as const;

export const intelligenceJobs = [
  {
    number: "01",
    title: "What is driving this?",
    description:
      "Rank the likely causes and show the evidence behind each one.",
  },
  {
    number: "02",
    title: "What fact should we get next?",
    description:
      "Identify the missing measurement most likely to change the decision.",
  },
  {
    number: "03",
    title: "Did the action work?",
    description:
      "Compare the measured result with the original baseline and turn it into evidence for the next decision.",
  },
] as const;

export const waterColumns = [
  {
    number: "01",
    title: "What we check",
    items: [
      "12 months of wastewater bills and surcharge statements",
      "The applicable tariff and charge formula",
      "Laboratory and flow results",
      "Sampling dates and operating conditions",
      "Production, cleaning, and maintenance events",
      "Chemical, sludge, and hauling costs",
    ],
  },
  {
    number: "02",
    title: "What management receives",
    items: [
      "Charges rebuilt from the formula",
      "A month-by-month reconstruction of where the increase appeared",
      "A check of whether the samples fairly reflect plant operations",
      "Ranked explanations with visible confidence",
      "The least expensive justified next move",
      "The next missing fact, a baseline, and one 90-day result check",
    ],
  },
] as const;
